import {HttpHandlerService} from "./HttpHandlerService";
import { StateService } from "@uirouter/angularjs";

export class FileDataService extends HttpHandlerService {
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http,$q,$state);
    }
    getBaseUrl():string{
        return "filedata";
    }
    insert(b64Data:string):ng.IPromise<number>{
        var postData:any = JSON.stringify(b64Data);
        return this.usePostHandler(this.getBaseUrl(),"", postData).then((data)=>{
            return this.$q.when(data)
        });
    }
    update(id:number,b64Data:string):ng.IPromise<boolean>{
        var postData:any = JSON.stringify(b64Data);
        return this.usePutHandler(this.getBaseUrl(),""+id, postData).then((data)=>{
            return this.$q.when(true)
        });
    }
    delete(id:number):ng.IPromise<boolean>{
        return this.useDeleteHandler(this.getBaseUrl(),""+id, {}).then((data)=>{
            return this.$q.when(true);
        });
    }
    get(id:number):ng.IPromise<string>{
        return this.useGetHandler(this.getBaseUrl(),""+id, {});
    }
    //getImage(id:number):ng.IPromise<any>{
    //    return this.useGetHandler(this.getBaseUrl(),"getImage?id="+id, {});
    //}
    getImageSize(id:number):ng.IPromise<string>{
        return this.useGetHandler(this.getBaseUrl(),"ImageSize/"+id, {});
    }

    getImageType(id:number):ng.IPromise<string>{
        return this.useGetHandler(this.getBaseUrl(),"ImageType/"+id, {});
    }

}
